import React from 'react'
import { JsonForms } from '@jsonforms/react'
import { materialCells } from '@jsonforms/material-renderers'
import Box from '@mui/material/Box'
import renderers from '~/client/jsonForms/renderers.js'

export default function JSONSchemaFormInput({
  value,
  onChange: _onChange,
  onErrors,
  schema,
  uiSchema,
  ...props
}){
  schema = React.useMemo(() => parseIfString(schema), [schema])
  uiSchema = React.useMemo(() => parseIfString(uiSchema), [uiSchema])
  const onChange = React.useCallback(
    ({ data: value, errors }) => {
      if (errors && errors.length > 0) {
        console.error('JSONSchemaFormInput errors', errors)
        if (onErrors) onErrors(errors)
      }
      _onChange(value)
    },
    [_onChange]
  )
  return <Box {...{
    ...props,
    sx: {
      ...props.sx,
      '& .MuiFormControl-root': {
        my: 1,
      },
      '& .MuiAccordionSummary-content .MuiAvatar-root': {
        display: 'none',
      }
    }
  }}>
    <JsonForms {...{
      schema,
      uischema: uiSchema || undefined,
      renderers,
      cells: materialCells,
      data: value,
      onChange
    }}/>
  </Box>
}

function parseIfString(json){
  return typeof json === 'string' ? JSON.parse(json) : json
}

